// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"footer_footerWrapper__Fh6W_","subscribeText":"footer_subscribeText__UsLno","subscribeButton":"footer_subscribeButton__7Y413"};